import React from "react";
import { Anchor } from "antd";
import { AxSearch } from "@dynata/axiom3";
import { componentList } from "../constants";

const { Link } = Anchor;

export default class ComponentsNav extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchVal: "",
    };
    this.onSearch = this.onSearch.bind(this);
  }
  onSearch(e) {
    this.setState({ searchVal: e.target.value });
  }
  render() {
    const { searchVal } = this.state;
    return (
      <>
        <div style={{ margin: "16px 0" }}>
          <AxSearch
            size="small"
            allowClear
            enterButton
            onChange={this.onSearch}
            value={searchVal}
            placeholder="Search components"
          />
        </div>
        {componentList.map((item, i) => {
          if (
            searchVal &&
            item.title.toLowerCase().indexOf(searchVal.toLowerCase()) === -1
          ) {
            return null;
          }
          return <Link key={i} href={item.href} title={item.title} />;
        })}
      </>
    );
  }
}
